module.exports = __webpack_public_path__ + "img/trustedDevices.c3feff77.png";